<template>
    <div :class="['search-panel', {
        'is-open': isPanelOpen,
        'is-collapsed': isCollapsed
    }]">
        <div v-if="isLoading"
             class="search-panel__preloader">
            <PreloaderIcon />
        </div>
        <OpenButton v-if="isMobile && !isLoading"
                    @openFilter="onFilterOpen" />
        <Filters v-if="!isLoading"
                 :data="data"
                 :isCollapsed="isCollapsed"
                 :isMobile="isMobile"
                 :isPanelOpen="isPanelOpen"
                 :priceChange="priceChange"
                 :windowWidth="windowWidth"
                 @closeFilter="onFilterClose"
                 @changeFilter="changeFilter"
                 @openFilter="onFilterOpen"/>
    </div>
</template>

<script>
import axios from 'axios';
import Filters from './Filters/Filters.vue';
import OpenButton from './OpenButton/OpenButton.vue';
import PreloaderIcon from './media/preloader-icon.vue';
import {Utils} from 'common/scripts/utils';

export default {
    data() {
        return {
            // позиционирование поиска
            position   : this.$dataset.position || 'static',
            // прелоадер
            isLoading  : true,
            // открыта ли панель
            isPanelOpen: false,
            // Зафиксирована ли панель
            isCollapsed: false,
            // Открыта ли панель пользователем
            isUserOpen : false,
            // ширина экрана
            windowWidth: Utils.getWindowWidth(),
            // данные для отправки на сервер
            sendData   : new FormData(),
            // данные, полученные с сервера
            data       : {},
            // менял ли пользователь цену
            priceChange: {
                min: false,
                max: false
            }
        };
    },

    computed: {
        isMobile() {
            return this.windowWidth < 960;
        }
    },

    components: {
        Filters,
        OpenButton,
        PreloaderIcon
    },

    created() {
        if (this.windowWidth >= 960) {
            this.isPanelOpen = true;
        }
    },

    mounted() {
        const events = ['resize', 'orientationchange'];

        events.forEach((event) => {
            window.addEventListener(event, this.onResize);
        });

        switch (this.position) {
            case 'fixed':
                this.isCollapsed = true;
                this.isPanelOpen = false;
                break;
            case 'sticky':
                this.setPosition();
                window.addEventListener('scroll', this.setPosition);
                break;
            case 'static':
            default:
                break;
        }

        this.send('init');
    },

    unmount() {
        const events = ['resize', 'orientationchange'];

        events.forEach((event) => {
            window.removeEventListener(event, this.onResize, false);
        });

        if (this.position === 'sticky') {
            window.removeEventListener('scroll', this.setPosition, false);
        }
    },

    methods: {
        onResize() {
            if (this.isMobile && Utils.getWindowWidth() >= 960) {
                this.isPanelOpen = true;
            }

            if (!this.isMobile && Utils.getWindowWidth() < 960) {
                this.isPanelOpen = false;
            }

            this.windowWidth = Utils.getWindowWidth();
        },

        onFilterOpen() {
            if (!this.isPanelOpen) {
                this.isPanelOpen = true;
                this.isUserOpen = true;
            }
        },

        onFilterClose() {
            if (this.isPanelOpen) {
                this.isPanelOpen = false;
                this.isUserOpen = false;
            }
        },

        /**
         * Добавляем data аттрибуты от главного элемента
         * @param {Object} formData - данные, куда присваиваются аттрибуты
         */
        addMainDataset(formData) {
            if (this.$dataset) {
                for (const key in this.$dataset) {
                    if (Object.prototype.hasOwnProperty.call(this.$dataset, key)) {
                        if (!formData.has(key)) {
                            formData.append(key, this.$dataset[key]);
                        }
                    }
                }
            }
        },

        /**
         * Отправка данных на сервер
         * @param {String} typeRequest - тип запроса
         */
        send(typeRequest = '') {
            // Добавляем дата-атрибуты
            this.addMainDataset(this.sendData);

            // Определяем тип поиска
            if (typeRequest === 'init') {
                this.sendData.append('mode', 'init');
            } else {
                this.sendData.append('mode', 'filter');
            }

            axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
            axios.post('/ajax/searchresult.php', this.sendData).then((response) => {
                const status = response.data.request.status;

                if (status) {
                    this.data = response.data.data;
                } else {
                    throw new Error('Ошибка на сервере');
                }
            })
                .then(() => {
                    this.isLoading = false;
                });
        },

        changeFilter(form, isTypeChanged) {
            this.sendData = new FormData(form);

            // Флаг, изменили ли тип выборки
            this.sendData.append('isTypeChanged', isTypeChanged);

            if (isTypeChanged) {
                this.resetPriceChange();
            }

            // Проверка потроганных пинов
            this.checkSendDataPrice();

            this.send();
        },

        checkSendDataPrice() {
            if (!this.priceChange.min) {
                this.sendData.delete('price[min]');
            }

            if (!this.priceChange.max) {
                this.sendData.delete('price[max]');
            }
        },

        resetPriceChange() {
            this.priceChange.min = false;
            this.priceChange.max = false;
        },

        setPosition() {
            const elementOffsetTop = this.$el.getBoundingClientRect().top;
            const elementHeight = this.$el.getBoundingClientRect().height;
            const windowHeight = window.innerHeight || document.documentElement.clientHeight;

            this.isCollapsed = elementOffsetTop + elementHeight <= 0 || elementOffsetTop >= windowHeight;

            if (this.windowWidth >= 960) {
                if (!this.isUserOpen) {
                    this.isPanelOpen = !this.isCollapsed;
                }

                if (!this.isCollapsed) {
                    this.isUserOpen = false;
                }
            }
        }
    }
};
</script>
